import { FieldTypeCategory } from '@thinkalpha/language-services';
export function getBaseTypeFromConcreteType(concreteType) {
    if (typeof concreteType === 'object') {
        const fieldType = 'series' in concreteType ? concreteType.series : concreteType.type;
        return fieldType;
    }
    return concreteType;
}
export function isNumericFieldType(type) {
    const fieldType = getBaseTypeFromConcreteType(type);
    const isDouble = fieldType === FieldTypeCategory.Double;
    return isDouble || fieldType === FieldTypeCategory.Int;
}
export function isDateTimeFieldType(type) {
    const fieldType = getBaseTypeFromConcreteType(type);
    return fieldType === FieldTypeCategory.Timestamp;
}
export function isStringFieldType(type) {
    const fieldType = getBaseTypeFromConcreteType(type);
    return fieldType === FieldTypeCategory.String;
}
